import coreReducer from './reducers';
export { default as coreOperations } from './operations';
export { default as coreTypes } from './types';
export default coreReducer;